export default {
      id: "oc-res-billdomain-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-billdomain",
      toString: function () {
        return this.url;
      }
    }